import { render, staticRenderFns } from "./ProjectThanks.vue?vue&type=template&id=04696e3d&scoped=true&"
import script from "./ProjectThanks.vue?vue&type=script&lang=js&"
export * from "./ProjectThanks.vue?vue&type=script&lang=js&"
import style0 from "./ProjectThanks.vue?vue&type=style&index=0&id=04696e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04696e3d",
  null
  
)

export default component.exports